import { Row, Spin } from 'antd'
import React, { useContext, useEffect, useRef } from 'react'
import LayoutComponent from 'component/layout'
import { useRedux } from 'redux/useRedux';
import BasketLogic from './basket_logic';

import { AuthContext } from 'contexts/auth-context';
import { BasketIcon } from 'assets/svgComponent';
import EmptyBox from './widget/emptyBox';
import SubscriptionItem from './widget/subscription_item';
import IconDiv from 'component/IconDiv';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getUserSubscription, onChangeBasket } from './redux/actions';


const Bank = () => {
  const { dispatch, basketState } = useRedux()
  const ctx = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  useEffect(() => {
    const status = searchParams.get("status"); 
    const orderId = searchParams.get("orderId"); 
    dispatch(onChangeBasket("statusPayment",status))
    dispatch(onChangeBasket("orderId",orderId))
   dispatch(getUserSubscription(ctx))

    navigate({ pathname: "/basket"},{state:{status,orderId}});
  }, [])

  return (
   <Spin  />
  )
}

export default Bank
